<div class="text-center">
    <mat-icon>developer_board</mat-icon>
    <h1 mat-dialog-title translate> dialog.slotautomate.update.title</h1>
  
    <div class="modal-body" mat-dialog-content>

        <div class="card container">
            
                <div class="col-md mt-3">
                    <mat-form-field class = "full-width">
                        <mat-label translate>tables.slotautomate.labels.service</mat-label>
                        <input [(ngModel)]="_slotAutomate.serviceName" matInput disabled>
                    </mat-form-field>
                </div>
                <div class="col-md">
                    <mat-form-field class = "full-width">
                    <mat-label translate>tables.slotautomate.labels.model</mat-label>
                    <mat-select [(ngModel)]="_slotAutomate.modelId" matNativeControl>
                        <mat-option *ngFor="let model of models" [value]="model.id">
                        {{model.name}}
                        </mat-option>
                    </mat-select>
                    </mat-form-field>
                </div>
                <div class="col-sm mt-3">
                    <mat-checkbox [(ngModel)]="_slotAutomate.enabled">
                        <span translate>tables.slotautomate.labels.enabled</span>
                    </mat-checkbox>
                </div>
            
        </div>

        <div class="card container mt-3">
            <div class="row mt-2">
                <div class="col-md">
                    <mat-form-field>
                    <mat-label translate>dialog.slotautomate.insertdate</mat-label>
                    <input  matInput 
                        [(ngModel)]     = "_slotAutomate.lastDate" 
                        [min]           = "today"
                        (change)        = "checkDate()"

                        [matDatepicker] = "datebegin">

                    <mat-datepicker-toggle matSuffix [for] ="datebegin">
                        <mat-icon matDatepickerToggleIcon>arrow_drop_down</mat-icon>
                    </mat-datepicker-toggle>

                    <mat-datepicker #datebegin></mat-datepicker>

                    </mat-form-field>

                </div>
                <div class="col-sm mt-3">
                    <mat-checkbox [(ngModel)]="_slotAutomate.holiday">
                        <span translate>tables.slotautomate.labels.holiday</span>
                    </mat-checkbox>
                </div>
            </div>
        </div>

        <div class="card container mt-3">
                
            <div class="row mt-2">
                <div class="col-sm">
                    <mat-form-field>
                        <mat-label translate>tables.slotautomate.labels.advance</mat-label>
                        <input [(ngModel)]="_slotAutomate.dayAdvance" matInput>
                    </mat-form-field>
                </div>
                <div class="col-sm">
                    <mat-form-field>
                        <mat-label translate>tables.slotautomate.labels.add</mat-label>
                        <input [(ngModel)]="_slotAutomate.dayAdd" matInput>
                    </mat-form-field>
                </div>
                
            </div>
        </div>

  
      
    </div>
  
  
    <div class="modal-footer" mat-dialog-actions translate>

        <button type="button" class="btn btn-outline-danger" (click)="cancel()" translate>
        dialog.service.generic.cancel
        </button>

        <button type="button" class="btn btn-outline-secondary" (click)="update()"
        translate>
        dialog.service.update.confirm
        </button>


    </div>

</div>